import { render } from "./Task.vue?vue&type=template&id=25f44a6a"
import script from "./Task.vue?vue&type=script&lang=js"
export * from "./Task.vue?vue&type=script&lang=js"

import "./Task.vue?vue&type=style&index=0&id=25f44a6a&scope=true&lang=css"

import exportComponent from "C:\\Users\\absan\\Documents\\GitHub\\Starport\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__